import { render, staticRenderFns } from "./AddNotification.vue?vue&type=template&id=410ac6e8"
import script from "./AddNotification.vue?vue&type=script&lang=js"
export * from "./AddNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports